import type { PlanRegion }       from '@models/map/dxfTypes';
import type { PlanSourceResult } from '@models/map/dxfTypes';

/** Rectangle en pixels, tel qu'un tracé à la souris le produit. */
export type DisplayBox = {
	minX: number;
	minY: number;
	maxX: number;
	maxY: number;
};

/**
 * Rectangle normalisé entre deux coins QUELCONQUES.
 *
 * Un cadre tracé à la souris part de n'importe lequel de ses quatre coins : normaliser ici
 * évite que chaque calcul en aval ait à se demander si `minX` est bien le plus petit.
 */
export function boxBetween(a: { x: number; y: number }, b: { x: number; y: number }): DisplayBox {
	return {
		minX: Math.min(a.x, b.x),
		minY: Math.min(a.y, b.y),
		maxX: Math.max(a.x, b.x),
		maxY: Math.max(a.y, b.y),
	};
}

/**
 * Le geste est-il un CLIC plutôt qu'un tracé ?
 *
 * Un clic n'applique rien : il évite d'appliquer
 * un rectangle d'un pixel qui ne contiendrait rien — l'opérateur verrait alors le plan
 * disparaître sans comprendre pourquoi.
 */
export function isClickRatherThanDrag(box: DisplayBox, minimum = 6): boolean {
	return box.maxX - box.minX < minimum || box.maxY - box.minY < minimum;
}

/** Libellé de l'état courant, pour que l'opérateur sache ce qui sera analysé. */
export function describeRegion(region: PlanRegion | null, source: Pick<PlanSourceResult, 'width' | 'height'>): string {
	if (!region) return 'Aucune zone : tout le plan sera analysé.';

	return `Zone : ${Math.round(region.maxX - region.minX)} × ${Math.round(region.maxY - region.minY)} px `
		+ `sur ${Math.round(source.width)} × ${Math.round(source.height)}.`;
}
